import CookiePopup from './CookiePopup.vue'

export default CookiePopup
